import React from 'react'
import DatePickerWrapper from '../DatePickerWrapper'
import styles from './CustomDatePicker.module.scss'
import CustomSelect from '../CustomSelect/CustomSelect'
import DatePicker from 'react-datepicker'
import { ReactComponent as Calendar } from 'components/UI/icons/calendar-line.svg'
import { monthsData } from 'components/UI/Calendar/utils.js'
import { years } from 'components/UI/Calendar/utils.js'
import useLocalization, { getLang } from 'hooks/useLocalization'
import kk from 'date-fns/locale/kk'

const CustomDatePicker = ({
  selectedDate,
  onChangeDate,
  maxDateInf,
  minDateInf,
  name,
}) => {
  const { translate } = useLocalization({
    section: 'profile',
    subsection: 'profile_modal_month',
    dict: {
      year: 'Year',
      month: 'Month',
    },
  })

  return (
    <div className={styles.datePikerContainer}>
      <Calendar className={styles.calendarIcon} />
      <DatePickerWrapper>
        <DatePicker
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className={styles.customHeaderSelect}>
              <div className={styles.selectMonth}>
                <div className={styles.dateName}>{translate.month}</div>
                <CustomSelect
                  options={monthsData}
                  onSelect={(option) => changeMonth(monthsData.indexOf(option))}
                  defaultValue={monthsData[date.getMonth()]}
                />
              </div>
              <div className={styles.selectYear}>
                <div className={styles.dateName}>{translate.year}</div>
                <CustomSelect
                  options={years}
                  onSelect={(option) => changeYear(option)}
                  defaultValue={date.getFullYear()}
                />
              </div>
            </div>
          )}
          selected={selectedDate}
          onChange={onChangeDate}
          dateFormat='dd.MM.yyyy'
          locale={getLang() === 'kz' ? kk : getLang()}
          maxDate={maxDateInf}
          minDate={minDateInf}
          placeholderText={name}
          withPortal
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode='select'
        />
      </DatePickerWrapper>
    </div>
  )
}

export default CustomDatePicker
